
import React, { useState,useEffect} from "react";

const documents = [

  {
     id: 41,
  category: "Annual Narrative Report",
  title: "Annual Narrative Report 2025",
  description: "Summary of the 2025 Narrative Report, including key highlights and insights.",
  image:  "/assets/d1.jpg",
  link: "/PDF/2025AnnualNarrativeReport.pdf",
  },
  {
  id: 42,
  category: "Annual Narrative Report",
  title: "Annual Narrative Report 2024",
  description: "Summary of the 2024 Narrative Report, including key highlights and insights.",
  image:  "/assets/d1.jpg",
  link: "/PDF/2024AnnualNarrativeReport.pdf",
  },
{
  id: 1,
  category: "Jobfair Reports",
  title: "2024 National Expo – SWOT Analysis",
  description: "A detailed SWOT analysis of the 2024 National Expo, highlighting strengths, weaknesses, opportunities, and threats observed during the event.",
  image: "/assets/img4.jpg",
  link: "/PDF/ProgramReports/JobFair/2024NationalExpoSWOTanalysis.pdf",
},
{
  id: 2,
  category: "Jobfair Reports",
  title: "Haramaya University Breakfast Forum – Summary Report",
  description: "A summary of key discussions and takeaways from the Breakfast Forum held at Haramaya University as part of Dereja’s job fair engagements in 2024.",
  image: "/assets/bf3.png",
  link: "/PDF/ProgramReports/JobFair/HaramayaBreakfastforumsummaryreport.pdf",
},
 {
    id: 3,
    category: "Data Management Report",
    title: "DAAP Supervision Report 2023",
    description: "Supervision findings and implementation quality for the DAAP program.",
    image: "/assets/daap4.jpg",
    link: "/PDF/ProgramAssessment/DAAPSupervisionReport.pdf",
  },
{
  id: 4,
  category: "Jobfair Reports",
  title: "Haramaya University Annual Milk Run Job Fair – Summary",
  description: "An overview of the 2024 Annual Milk Run Job Fair conducted at Haramaya University, including employer engagement and youth participation metrics.",
  image: "/assets/breakfastforum.png",
  link: "/PDF/ProgramReports/JobFair/HaramayaUniversityAnnualMilkRunJobFairSummaryReport.pdf",
},
{
  id: 5,
  category: "Jobfair Reports",
  title: "Hawassa University Job Fair Report",
  description: "Insights and highlights from the job fair conducted at Hawassa University in 2024, showcasing collaboration between employers and job seekers.",
  image: "/assets/101.png",
  link: "/PDF/ProgramReports/JobFair/HawassJobFair.pdf",
},
{
  id: 6,
  category: "Jobfair Reports",
  title: "Jimma University Job Fair Report",
  description: "A summary of the job fair hosted at Jimma University in 2024, featuring partner engagement and outcomes from youth-employer interactions.",
  image: "/assets/hjf.png",
  link: "/PDF/ProgramReports/JobFair/JimmaJobFair.pdf",
},
{
  id: 7,
  category: "Jobfair Reports",
  title: "Jimma University Breakfast Forum – Summary Report",
  description: "Highlights from the breakfast forum organized alongside the Jimma job fair, focused on employability, collaboration, and future directions.",
  image: "/assets/bf1.png",
  link: "/PDF/ProgramReports/JobFair/JimmaBreakfastforumReport.pdf",
},
{
  id: 8,
  category: "Jobfair Reports",
  title: "Jimma University Job Fair Report",
  description: "Details of the job fair conducted at Jimma University, featuring employer participation and youth engagement activities.",
  image: "/assets/hawassajf.png",
  link: "/PDF/ProgramReports/JobFair/JimmaJobFair.pdf",
},
{
  id: 9,
  category: "Jobfair Reports",
  title: "2024 National Expo – Assessment Report",
  description: "Evaluation and assessment of the 2024 National Expo with performance insights and recommendations.",
  image: "/assets/img4.jpg",
  link: "/PDF/ProgramReports/JobFair/ME2024ExpoAssessmentsReport.pdf",
},
{
  id: 10,
  category: "Jobfair Reports",
  title: "Pre and Post Job Fair Survey – Key Findings",
  description: "Analysis of participant feedback and outcomes gathered before and after Dereja’s job fairs of 2024, measuring program impact and effectiveness.",
  image: "/assets/prepost.jpg",
  link: "/PDF/ProgramReports/JobFair/PreandPostJobFairSurveyFindings.pdf",
},
{
  id: 11,
  category: "Jobfair Reports",
  title: "Regional Milk Run Job Fair – Bahir Dar University",
  description: "A summary of the regional job fair held at Bahir Dar University, part of Dereja’s Milk Run initiative promoting employment access.",
  image: "/assets/102bdu.png",
  link: "/PDF/ProgramReports/JobFair/RegionalMilkrunJobfairReportSummaryBahirDaruniversity.pdf",
},
{
  id: 12,
  category: "Jobfair Reports",
  title: "Wollo University Breakfast Forum – Summary",
  description: "Discussion points and outcomes from the Wollo University breakfast forum, aligned with Dereja’s job fair and youth engagement strategy.",
  image: "/assets/bf2.png",
  link: "/PDF/ProgramReports/JobFair/WolloBreakfastforumsummaryreport.pdf",
},
{
  id: 13,
  category: "Jobfair Reports",
  title: "Regional Milk Run Job Fair – Wollo University",
  description: "Highlights from the regional job fair at Wollo University under the Milk Run annual job fair, fostering graduate-employer linkages.",
  image: "/assets/wollo.png",
  link: "/PDF/ProgramReports/JobFair/WolloRegionalMilkrunJobfairSummary.pdf",
},

  {
    id: 14,
    category: "Progress Reports",
    title: "8 month progress Report ",
    description: "Highlights of key accomplishments and program activities over the first 8 months of 2024.",
    image: "/assets/da.webp",
    link: "/PDF/ProgramReports/DerejaInterventionsmonthsProgressReport.pdf",
  },
  {
    id: 15,
    category: "Evaluation Report",
    title: "Evalution Report",
    description: "Insights into the impact and effectiveness of the Career Compass program in 2024.",
    image: "/assets/careerc.png",
    link: "/PDF/ProgramReports/CareerCompassEvaluatioReport.pdf",
  },
  {
    id: 16,
    category: "Internship Report",
    title: "Internship Report",
    description: "Insights into the Impact and Effectiveness of the Regional Internship Program in 2024.",
    image: "/assets/careerc.png",
    link: "/PDF/ProgramReports/RegionalInternshipProgramReport.pdf",
  },
   {
    id: 17,
    category: "Campaign Reports",
    title: "2023 Annual Campaign AASTU Report",
    description: "Program Campaign in 2023 at Addis Ababa Science and Technology University.",
    image: "/assets/campaignasstu.png",
    link: "/PDF/ProgramReports/CampaignReports/AASTUCampaignreportformt.pdf",
  },
   {
    id: 18,
    category: "Campaign Reports",
    title: "2023 Annual Campaign AAU Report",
    description: "Campaign Activities Conducted in 2023 at Addis Ababa University",
    image: "/assets/campaignaau2023.png",
    link: "/PDF/ProgramReports/CampaignReports/AAUCampaignReport2023.pdf",
  },
   {
    id: 19,
    category: "Campaign Reports",
    title: "2023 Jimma University Campaign Report",
    description: "A report showcasing the program outreach activity in 2023",
    image: "/assets/jimma.png",
    link: "/PDF/ProgramReports/CampaignReports/CampaignreportJimma.pdf",
  },
   {
    id: 20,
    category: "Campaign Reports",
    title: "2023 Debre Birhan University campaign Report",
    description: "A Campaign Held in 2023 at Debire Birhan  University",
    image: "/assets/bducampaign.png",
    link: "/PDF/ProgramReports/CampaignReports/DebreBerhanUniveristyCampaignreportEdited.pdf",
  },
  {
    id: 21,
    category: "Campaign Reports",
    title: "2023 Annual Campaign ASTU Report",
    description: "Program Outreach at Adama science & technology university in 2023",
    image: "/assets/campaign1.png",
    link: "/PDF/ProgramReports/CampaignReports/ASTUCampaignreport2023.pdf",
  },
   {
    id: 22,
    category: "Campaign Reports",
    title: "2023 Annual AASTU Campaign Report",
    description: "Campaign Outreach at Addis Ababa Science and Technology University in 2023",
    image: "/assets/campaign2.png",
    link: "/PDF/ProgramReports/CampaignReports/Campaignreport2023AASTU.pdf",
  },
   {
    id: 23,
    category: "Campaign Reports",
    title: "2023 Annual Campaign Wolkite Report",
    description: "Campaign Activities Conducted in 2023 at Wolkite University",
    image: "/assets/campaignwku.png",
    link: "/PDF/ProgramReports/CampaignReports/Campaignreport2023WolkiteUniversity.pdf",
  },
    {
    id: 24,
    category: "Campaign Reports",
    title: "2023 Annual Campaign Report",
    description: "A Campaign Held in 2023 at Bahirdar University",
    image: "/assets/campaignbdu.png",
    link: "/PDF/ProgramReports/CampaignReports/CampaignReportBDUDereja2023.pdf",
  },
   {
    id: 25,
    category: "Campaign Reports",
    title: "2023 Annual Campaign Report",
    description: "Campaign Activities Conducted in 2023 at DireDawa University.",
    image: "/assets/campaigndiredewa.png",
    link: "/PDF/ProgramReports/CampaignReports/CampaignReportDireDawaJune3June42022.pdf",
  },
   {
    id: 26,
    category: "Campaign Reports",
    title: "2023 Annual campaign Arbaminch Report",
    description: "A Campaign Held in 2023 at Bahirdar University",
    image: "/assets/campaignarbaminch.png",
    link: "/PDF/ProgramReports/CampaignReports/CampaignreportformatArbaminch.pdf",
  },
   {
    id: 27,
    category: "Campaign Reports",
    title: "2023 Hawassa University Campaign Report",
    description: "A report showcasing the program outreach activity in 2023.",
    image: "/assets/j2.png",
    link: "/PDF/ProgramReports/CampaignReports/CampaignreportHawassa.pdf",
  },
{
    id: 28,
    category: "Meeting Report",
    title: "Evalution Report",
    description: "A monthly meeting report ppt with MCF June,2022.",
    image: "/assets/careerc.png",
    link: "/PDF/ProgramReports/DerejaMCFMonthlyMeetingJune.pdf",
  },

  {
    id: 29,
    category: "TOT Reports",
    title: "Training of Trainers Snapshot",
    description: "Key milestones and achievements from the Training of Trainers program of to 2022.",
    image: "/assets/tot.png",
    link: "/PDF/ProgramReports/DAAP2022TOTTrainingReportFinal.pdf",
  },
  
  {
    id: 30,
    category: "ESJR TOT Reports",
    title: "ESJR TOT Report",
    description: "Comprehensive report on the Employability and Job Readiness Training of Trainers (ToT) program, highlighting key outcomes and impact.",
    image: "/assets/esjr1.jpg",
    link: "/PDF/ProgramReports/EmployabilityandJobReadinessToTTrainingFullReportApril2022.pdf",
  },

{
  id: 31,
  category: "Impact Reports",
  title: "Dereja Capabilities Statement",
  description: "An overview of Dereja’s core services, capacity, and impact in supporting youth employability in 2022.",
  image: "/assets/meri.png",
  link: "/PDF/ProgramReports/Derejacapabillitiesstatement.pdf",
},
  {
  id: 32,
  category: "Impact Reports",
  title: "Training of Trainers Report – Wachamo University",
  description: "Detailed outcomes and learnings from the ToT program conducted at Wachamo University in collaboration with Dereja.",
  image: "/assets/esjr2.jpg",
  link: "/PDF/ProgramReports/TOTReportWachamo.pdf",
},

{
  id: 33,
  category: "Impact Reports",
  title: "Dereja Webapp Tracking System Report",
  description: "This report presents an advanced online platform developed to transform the way candidate placements are tracked and managed. By shifting from manual, paper-based methods to a centralized digital system, the platform offers real-time data collection, monitoring, and reporting capabilities.",
  image: "/assets/webapp.jpg",
  link: "/PDF/ProgramReports/DerejaWebappTrackingSystem.pdf",
},
{
    id: 34,
    category: "Instructor Seminar",
    title: "2024 Instructor Seminar at Haramaya University",
    description: "Report on the 2024 instructor seminar conducted at Haramaya University.",
    image: "/assets/Screenshot 20250617143942.jpg", 
    link: "/PDF/StakeholderInsights/ReportofInstructorSeminarinHaramayaUniversity2024.pdf",
  },
  {
    id: 35,
    category: "Stakeholder Workshop",
    title: "Seminar - Hawassa University",
    description: "Workshop report focused on University-Industry Linkage (UIL) hosted at Hawassa University to gain insightts from industries around Hawassa.",
   image: "/assets/seminar.webp",
    link: "/PDF/StakeholderInsights/UILWorkshopHawassaReport.pdf",
  },
{
    id: 36,
    category: "Stakeholder Workshop",
    title: "Seminar – Arbaminch University",
    description: "A comprehensive report from the University-Industry Linkage (UIL) seminar held at Arbaminch University, highlighting key takeaways from regional industry participants.",
    image: "/assets/seminar.webp",
    link: "/PDF/InstructorsSeminarReports/Arbamnchinstructorseminarreport.pdf",
  },
  {
    id: 37,
    category: "Stakeholder Workshop",
    title: "Seminar – Hawassa University",
    description: "Insights from the University-Industry Linkage (UIL) workshop at Hawassa University, focused on enhancing collaboration between local industries and academia.",
    image: "/assets/seminar.webp",
    link: "/PDF/InstructorsSeminarReports/HawassaInstSeminarReport.pdf",
  },
  {
    id: 38,
    category: "Stakeholder Workshop",
    title: "Seminar – Jimma University",
    description: "A detailed report from Jimma University's seminar, outlining strategies to bridge the gap between higher education and industry needs.",
    image: "/assets/seminar.webp",
    link: "/PDF/InstructorsSeminarReports/InstructorSeminarJimmaUniversityreport.pdf",
  },
  {
    id: 39,
    category: "Stakeholder Workshop",
    title: "Outcome Report – National Summary",
    description: "A summary report on the outcomes and feedback collected across various instructor seminars, providing cross-institutional insights.",
    image: "/assets/seminar.webp",
    link: "/PDF/InstructorsSeminarReports/InstructorSeminarOutcome1.pdf",
  },
  {
    id: 40,
    category: "Stakeholder Workshop",
    title: "Seminar – Haramaya University",
    description: "This report captures discussions and recommendations from the instructor seminar held at Haramaya University as part of the UIL initiative in 2024.",
    image: "/assets/seminar.webp",
    link: "/PDF/InstructorsSeminarReports/ReportofInstructorSeminarinHaramayaUniversity2024.pdf",
  },
  {
  id: 41,
  category: "Jobfair Reports",
  title: "Jimma Breakfast Forum",
  description: "Highlights from the regional Breakfast Forum at Jimma University under the Milk Run annual job fair, fostering graduate-employer linkages.",
  image: "/assets/wollo.png",
  link: "/PDF/ProgramReports/JobFair/JimmaBreakfastforumReport.pdf",
 },
   {
  id: 44,
  category: "Annual Narrative Report",
  title: "Annual Narrative Report 2023",
  description: "Summary of the 2023 Narrative Report, including key highlights and insights.",
  image:  "/assets/d1.jpg",
  link: "/PDF/2023yearlynarrativesummaryreport.pdf",
  },
  {
  id: 45,
  category: "Annual Narrative Report",
  title: "Annual Narrative Report 2021",
  description: "Summary of the 2021 Narrative Report, including key highlights and insights.",
  image:  "/assets/d1.jpg",
  link: "/PDF/Dereja2021narrativereport.pdf",
  },
  {
  id: 46,
  category: "Annual Narrative Report",
  title: "Annual Narrative Report 2020",
  description: "Summary of the 2020 Narrative Report, including key highlights and insights.",
  image:  "/assets/d1.jpg",
  link: "/PDF/Final2020ANNUALNARRATIVEREPORT.pdf",
  },
];

export default function KnowledgeLibrary() {
  useEffect(() => {
        window.scrollTo(0, 0); 
      }, []);
  const [searchTerm, setSearchTerm] = useState("");
  const [page, setPage] = useState(0);
  const itemsPerPage = 6;

  
  const filteredDocs = documents.filter((doc) =>
    doc.title.toLowerCase().includes(searchTerm.toLowerCase()) ||
    doc.description.toLowerCase().includes(searchTerm.toLowerCase())
  );

  const totalPages = Math.ceil(filteredDocs.length / itemsPerPage);
  const startIndex = page * itemsPerPage;
  const paginatedDocs = filteredDocs.slice(startIndex, startIndex + itemsPerPage);

  const handleNext = () => {
    if (page < totalPages - 1) setPage(page + 1);
  };

  const handlePrev = () => {
    if (page > 0) setPage(page - 1);
  };

  const handleSearch = (e) => {
    setSearchTerm(e.target.value);
    setPage(0); 
  };

  return (
    <div className="p-6 bg-gray-100 min-h-screen">
      <h1 className="text-3xl font-bold text-orange mb-6 text-center">
        Knowledge Management Library
      </h1>

      <div className="max-w-2xl mx-auto mb-8">
        <input
          type="text"
          placeholder="Search documents..."
          className="w-full p-3 border border-gray-300 rounded-lg focus:outline-none focus:ring-2 focus:ring-orange-400"
          onChange={handleSearch}
          value={searchTerm}
        />
        <p className="text-sm text-gray-600 mt-2">
          {filteredDocs.length > 0
            ? `Showing ${startIndex + 1}-${Math.min(
                startIndex + paginatedDocs.length,
                filteredDocs.length
              )} of ${filteredDocs.length} documents`
            : `No results found for "${searchTerm}"`}
        </p>
      </div>

      {filteredDocs.length > 0 ? (
        <>
          <div className="grid sm:grid-cols-2 md:grid-cols-3 gap-6 mb-8">
            {paginatedDocs.map((doc) => (
              <div
                key={doc.id}
                className="bg-white rounded-xl shadow hover:shadow-md p-4"
              >
                <img
                  src={doc.image}
                  alt={doc.title}
                  className="h-40 w-full object-cover rounded-md mb-4"
                />
                <h3 className="text-lg font-semibold text-gray-800">
                  {doc.title}
                </h3>
                <p className="text-sm text-gray-600">{doc.description}</p>
                <a
                  href={doc.link}
                  target="_blank"
                  rel="noopener noreferrer"
                  className="mt-3 inline-block text-orange-600 hover:underline text-sm"
                >
                  View Document
                </a>
              </div>
            ))}
          </div>

          <div className="flex justify-center gap-4">
            <button
              onClick={handlePrev}
              disabled={page === 0}
              className={`px-4 py-2 rounded-md font-semibold ${
                page === 0
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Previous
            </button>
            <button
              onClick={handleNext}
              disabled={page >= totalPages - 1}
              className={`px-4 py-2 rounded-md font-semibold ${
                page >= totalPages - 1
                  ? "bg-gray-300 text-gray-500 cursor-not-allowed"
                  : "bg-orange text-white hover:bg-orange-600"
              }`}
            >
              Next
            </button>
          </div>
        </>
      ) : (
        <div className="text-center text-gray-500 text-lg mt-20">
          📄 No documents match your search.
        </div>
      )}
    </div>
  );
}
